module.exports = __webpack_public_path__ + "static/media/7.81178e08.png";